import React, { ReactChild } from 'react';

import { InterfaceSettingsContext, InterfaceSettingsModel } from './context';

type InterfaceSettingsProps = InterfaceSettingsModel & {
  children: ReactChild;
};

export const InterfaceSettingsProvider = ({
  children,
  ...props
}: InterfaceSettingsProps) => {
  return (
    <InterfaceSettingsContext.Provider value={props}>
      {children}
    </InterfaceSettingsContext.Provider>
  );
};

export default InterfaceSettingsProvider;
